import Component from './component';
import createComponentFactory from '../createComponent';
import FileLoader from '../utils/loader/FileLoader';


const defaultOptions = {
  defaultSrc: '',
  srcSet: []
};

class MovieHero extends Component {

  constructor(element, context, options) {
    super(element, context, Object.assign({}, defaultOptions, options));


    this._video = element.querySelector('.js-movieHero__video');

    this.loader = null;

    this._handleWindowLoad = this._handleWindowLoad.bind(this);
    this._handleLoaderComplete = this._handleLoaderComplete.bind(this);
  }

  _bindEvents() {
    window.addEventListener('load', this._handleWindowLoad);
  }

  _unbindEvents() {
    window.removeEventListener('load', this._handleWindowLoad);
  }

  _handleWindowLoad() {
    this._loadVideo();
  }

  _loadVideo() {


    const src = this._findMatchedSource();

    this.loader = new FileLoader(src);
    this.loader.load();

    this.loader.on('complete', this._handleLoaderComplete);
  }

  _handleLoaderComplete(result) {
    this.loader.off('complete', this._handleLoaderComplete);

    this._video.setAttribute('playsinline', '');
    this._video.setAttribute('webkit-playsinline', '');

    this._video.muted = true;
    this._video.autoplay = true;
    this._video.loop = true;


    this._video.src = URL.createObjectURL(this.loader._file);
    this._video.play();

  }

  _findMatchedSource() {
    const opts = this.options;

    // srcsetがマッチしていなかったらこれが読み込みされる
    const defaultVideo = opts.defaultSrc;

    // mediaqueryで読み込みを分岐する場合
    const srcSet = opts.srcSet;

    if(srcSet.length === 0) {
      return defaultVideo;
    }

    const found = srcSet.find((set) => {
      return window.matchMedia(set.mediaQuery).matches;
    });

    return found === undefined ? defaultVideo : found.src;
  }


  didRegisterComponent() {
    this._bindEvents();
  }

  didUnregisterComponent() {
    this._unbindEvents();
  }

}

export default createComponentFactory(MovieHero);



// WEBPACK FOOTER //
// ./src/js/app/component/movieHero.js